export default "__VITE_ASSET__CipEWLt$__"